import {  useMemo } from 'react'
import { BacnetObjectTypes, BacnetPropertyMappingConfiguration, useGetPropertyMappingsFromDeviceQuery } from '../../services/mapping/bacnet';


const useGetBacnetPropertyMappingsByObject = (edgeDeviceId: string, bacnetDeviceId: number, bacnetObjectType: BacnetObjectTypes, bacnetInstanceId: number): {
    count: number,
    objects: BacnetPropertyMappingConfiguration[] | undefined,
    error: any,
    isLoading: boolean,
    isSuccess: boolean,
} => {

    const { data, isLoading, isSuccess, error } = useGetPropertyMappingsFromDeviceQuery({ edgeDeviceId: edgeDeviceId, bacnetDeviceId: bacnetDeviceId});
    
    const items = useMemo(() => {
        return data?.filter(v => v.bacnetObjectInstanceId === bacnetInstanceId && v.bacnetObjectType === bacnetObjectType) ?? [];
    }, [data,bacnetInstanceId,bacnetObjectType]);


    return {
        count: items.length,
        objects: items,
        error: error,
        isLoading: isLoading,
        isSuccess: isSuccess,
    }
}

export default useGetBacnetPropertyMappingsByObject